import { Outlet } from "react-router-dom";
import type { ReactNode } from "react";
import { BottomMenu } from "../components/ui/BottomMenu";

export function AppLayout({ overlay }: { overlay?: ReactNode }) {
  return (
    <div className="h-dvh flex flex-col overflow-hidden bg-background">
      <a href="#main-content"
        onClick={(event) => { event.preventDefault(); document.getElementById("main-content")?.focus(); }}
        className="sr-only focus:not-sr-only focus:absolute focus:z-50 focus:rounded-xl focus:bg-card focus:p-3">Skip to content</a>
      <main id="main-content" tabIndex={-1} className="min-h-0 flex-1 overflow-hidden">
        <Outlet />
        {overlay}
      </main>
      <BottomMenu />
    </div>
  );
}
